import DatePickerCalendar from "./DatePickerCalendar.vue";
import { pluginify } from "./../../util";
export default pluginify(DatePickerCalendar);
export { DatePickerCalendar };
